import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { assets } from './data/landing';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AppShowcase } from './components/AppShowcase';
import { WhatYouFind } from './components/WhatYouFind';
import { TakeawaysSection } from './components/TakeawaysSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="relative w-full min-h-full overflow-hidden bg-cream font-sans antialiased" data-id="element-0" data-mp="2whx8rm2ytac0">
      {/* Detalle decorativo: hocico asomando desde la esquina superior izquierda, detrás del contenido. */}
      <img src={assets.dogSnout} alt="" aria-hidden="true" className="pointer-events-none absolute -left-12 -top-10 z-0 w-[420px] select-none sm:-left-14 sm:w-[470px]" data-id="element-1" data-mp="23t8eo70bu59r" />

      <noscript data-id="element-2" data-mp="3mj6lu3b7icj5">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-3" data-mp="3rcj31sdk3h1v" />
      </noscript>
      <Header data-id="element-4" data-mp="2zm4zaoz9bl3x" />
      <main data-id="element-5" data-mp="2zmo4r67q0h12">
        <Hero data-id="element-6" data-mp="2zmwggus3xgao" />
        <AppShowcase data-id="element-7" data-mp="2zng0qi58cgrv" />
        <WhatYouFind data-id="element-8" data-mp="33mf0loc3tncg" />
        <TakeawaysSection data-id="element-9" data-mp="33nq6btp41567" />
        <PricingSection data-id="element-10" data-mp="33n6w6z5pbl2q" />
        <GuaranteeSection data-id="element-11" data-mp="33oi0r16z0wuw" />
        <FaqSection data-id="element-12" data-mp="38l8gtoirzsgb" />
        <ClosingSection data-id="element-13" data-mp="38kqfwel64q22" />
      </main>
      <Footer data-id="element-14" data-mp="38nupxslbeg0n" />
    </div>;
}